import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
    imprestApplicationsByUser,
  leaveApplications,
  leaveApplicationsByUser,
  imprestApprover,
  approvedDisbursedImprests,
  ApprovedDisbursedClaims,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { LeaveApplicationsColumns, approvedClaimstApplicationsColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import ClaimApplicationForm from "./form";
import StaffClaimDocumentsDrawer from "./StaffClaimDocumentsDrawer";

const base_url = HRService.uri;

function StaffClaimsApprovedTable() {
  const [docsDrawerOpen, setDocsDrawerOpen] = useState(false);
  const [selectedRecordForDocs, setSelectedRecordForDocs] = useState(null);

  const actions = {
  entity: "Claim Applications",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

//  // ---------- APPROVE ----------
//   APPROVECLAIM: {
//     key: "APPROVECLAIM",
//     button_name: "Approve",
//     Show_Button: (row) => row.statusId === 1,   // only when pending
//     permission: "hasNoPermission",
//     roleGroupId: [1, 2, 3, 4],
//   },

//   // ---------- REJECT ----------
//   REJECTCLAIM: {
//     key: "REJECTCLAIM",
//     button_name: "Reject",
//     Show_Button: (row) => row.statusId === 1,   // only when pending
//     permission: "hasNoPermission",
//     roleGroupId: [1, 2, 3, 4],
//   },
    ViewClaimLines: {
      key: "ViewClaimLines",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewDocuments: {
      key: "ViewDocuments",
      button_name: "View Documents",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row) => {
        setSelectedRecordForDocs(row);
        setDocsDrawerOpen(true);
      },
    },
  showStatus: true,
};

  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Approved Disbursed Claim Apllications"
          subtitle="View all your Approved Disbursed Claim Apllications, create or update it"
          columns={approvedClaimstApplicationsColumns}
          FormComponent={ClaimApplicationForm}
          query={ApprovedDisbursedClaims}
          actions={actions}
          base_url={base_url}
        />
        <StaffClaimDocumentsDrawer
          open={docsDrawerOpen}
          onClose={() => {
            setDocsDrawerOpen(false);
            setSelectedRecordForDocs(null);
          }}
          claimId={selectedRecordForDocs?.id}
        />
      </>
    </Box>
  );
}

export default StaffClaimsApprovedTable;
